import {cloneDeep as _cloneDeep} from 'lodash';
import RoomTypesModel from "./../../models/RoomTypesModel"
const RoomTypesModule = {
    namespaced: true,
    state: () => ({
        roomTypes: [],
        roomType: _cloneDeep(RoomTypesModel, true),
    }),
    getters: {
        getRoomTypes (state) {
            return state.roomTypes
        },
        getRoomType (state) {
            return state.roomType
        },
    },
    mutations: {
        setRoomTypes (state, payload) {
            state.roomTypes = payload
        },
        setRoomType (state, payload) {
            state.roomType = payload
        },
    },
    actions: {
        setRoomTypes (context, payload) {
            context.commit('setRoomTypes', payload);
        },
        setRoomType (context, payload) {
            context.commit('setRoomType', payload);
        },
    },

}

export default RoomTypesModule;
